/* no-default-variant.js — Nimbus 1.8 / Dawn OS2.0
   默认不选择变体 + 多语言提示 + 动态区块兼容
*/

(function () {
  console.log('SOLKATT variant script loaded');

  if (new URLSearchParams(location.search).has('variant')) {
    console.log('SOLKATT: variant parameter detected, script stopped');
    return;
  }

  var userInteracted = false;
  var resetting = false;

  function getVariantPicker(form) {
    if (!form || !form.isConnected || form.closest('.quick-add, .card-wrapper')) return null;
    var main = form.closest('[id^="MainProduct-"]');
    if (!main) return null;
    return Array.from(main.querySelectorAll('variant-selects, variant-radios')).find(function (picker) {
      return Array.from(picker.querySelectorAll('input[type="radio"], select')).some(function (control) {
        return control.form === form;
      });
    }) || null;
  }


  // =========================================================
  // 根据任意 variant 控件找到它关联的 product form
  // Nimbus 1.8 的 variant input 可能不在 form 内，
  // 而是通过 form="product-form-xxx" 与表单关联
  // =========================================================
  function getProductFormFromTarget(target) {
    if (!target) return null;

    // 旧结构：控件本身位于 form 内
    var form =
      target.closest &&
      target.closest('product-form form, form[action*="/cart/add"]');

    if (form) return form;

    // Nimbus 1.8：通过 form 属性关联
    var formId =
      target.getAttribute &&
      target.getAttribute('form');

    if (formId) {
      return document.getElementById(formId);
    }

    // 如果点的是 label，尝试找到对应 input
    if (target.tagName === 'LABEL') {
      var forId = target.getAttribute('for');

      if (forId) {
        var input = document.getElementById(forId);

        if (input) {
          return getProductFormFromTarget(input);
        }
      }
    }

    return null;
  }

  // =========================================================
  // 获取某个 form 对应的 variant controls
  // 同时兼容：
  // 1. 控件位于 form 内
  // 2. 控件在外部但带 form="xxx"
  // =========================================================
  function getAssociatedControls(form, selector) {
    if (!form) return [];

    var picker = getVariantPicker(form);
    var controls = picker ? Array.from(picker.querySelectorAll(selector)).filter(function (control) {
      return control.form === form;
    }) : [];

    return controls;
  }

  // =========================================================
  // 当前语言提示文字
  // =========================================================
  function getSelectPrompt() {
    var lang = (document.documentElement.lang || 'en').toLowerCase();

    if (lang.startsWith('fr')) {
      return 'Sélectionnez une option';
    }

    if (lang.startsWith('zh')) {
      return '请选择规格';
    }

    return 'Select an option';
  }

  // =========================================================
  // 清空商品表单默认 variant
  // =========================================================
  function resetForm(form) {
    if (!getVariantPicker(form) || userInteracted) return;

    resetting = true;

    var idInput = form.querySelector('input[name="id"]');

    var addBtn =
      form.querySelector('button[name="add"]') ||
      form.querySelector('[type="submit"]');

    // ---------------------------------------------------------
    // 1. 清空隐藏 variant ID
    // ---------------------------------------------------------
    if (idInput) {
      idInput.value = '';
      idInput.removeAttribute('value');
    }

    // ---------------------------------------------------------
    // 2. 清空 radio / swatch / button
    // Nimbus 1.8 的 radio 可能在 form 外
    // ---------------------------------------------------------
    getAssociatedControls(form, 'input[type="radio"]').forEach(function (radio) {
      radio.checked = false;
      radio.removeAttribute('checked');

      if (radio.hasAttribute('aria-checked')) {
        radio.setAttribute('aria-checked', 'false');
      }
    });

    // ---------------------------------------------------------
    // 3. 下拉菜单回到未选择状态
    // 不主动 dispatch change，防止主题重新写回第一个 variant
    // ---------------------------------------------------------
    getAssociatedControls(form, 'select').forEach(function (sel) {
      if (sel.options.length && sel.options[0].value === '') {
        sel.selectedIndex = 0;
      } else {
        sel.selectedIndex = -1;
      }
    });

    // ---------------------------------------------------------
    // 4. 清除视觉上的 selected / active 状态
    // ---------------------------------------------------------
    var scope = getVariantPicker(form);

    scope
      .querySelectorAll(
        '.is-selected, .selected, .active, [aria-pressed="true"]'
      )
      .forEach(function (el) {
        el.classList.remove('is-selected', 'selected', 'active');

        if (el.hasAttribute('aria-pressed')) {
          el.setAttribute('aria-pressed', 'false');
        }
      });

    // ---------------------------------------------------------
    // 5. 禁用 Add to cart
    // ---------------------------------------------------------
    if (addBtn) {
      addBtn.disabled = true;
      addBtn.setAttribute('aria-disabled', 'true');

      // 第一次执行时保存主题原本按钮文字
      if (!addBtn.dataset.originalText) {
        addBtn.dataset.originalText = addBtn.textContent.trim();
      }

      addBtn.textContent =
        addBtn.dataset.selectPrompt || getSelectPrompt();
    }

    resetting = false;
  }

  // =========================================================
  // 只有真实用户操作才算 userInteracted
  // Nimbus 自己 JS 触发的 change 不算
  // =========================================================
  document.addEventListener(
    'change',
    function (e) {
      if (resetting) return;

      // 关键：忽略脚本自动触发的 change
      if (!e.isTrusted) return;

      var target = e.target;

      if (
        target &&
        (
          target.matches('input[type="radio"]') ||
          target.matches('select') ||
          target.closest('variant-selects') ||
          target.closest('variant-radios') ||
          target.closest('.product-form__input')
        )
      ) {
        var form = getProductFormFromTarget(target);

        if (getVariantPicker(form)) {
          userInteracted = true;
        }
      }
    },
    true
  );

  // =========================================================
  // 真实点击监听
  // =========================================================
  document.addEventListener(
    'click',
    function (e) {
      if (resetting) return;

      // 关键：忽略脚本模拟点击
      if (!e.isTrusted) return;

      var target = e.target;

      if (
        target &&
        target.closest &&
        target.closest(
          'variant-radios, variant-selects, .product-form__input, [role="radio"], [data-option], label[for]'
        )
      ) {
        var control =
          target.closest('input, select') ||
          target.closest('label');

        if (control && control.tagName === 'LABEL') {
          var forId = control.getAttribute('for');

          if (forId) {
            control =
              document.getElementById(forId) ||
              control;
          }
        }

        var form =
          getProductFormFromTarget(control || target);

        if (getVariantPicker(form)) {
          userInteracted = true;
        }
      }
    },
    true
  );

  // =========================================================
  // 为单个商品表单安装初始化逻辑
  // =========================================================
  function armForm(form) {
    if (!getVariantPicker(form)) return;

    // 避免重复 arm
    if (form.dataset.noDefaultVariantArmed === 'true') {
      return;
    }

    form.dataset.noDefaultVariantArmed = 'true';

    // Nimbus 初始化有延迟，多次覆盖
    var ticks = [0, 50, 120, 250, 500, 800, 1200];

    ticks.forEach(function (t) {
      setTimeout(function () {
        if (!userInteracted) {
          resetForm(form);
        }
      }, t);
    });

    // ---------------------------------------------------------
    // 观察隐藏 variant ID
    // 如果 Nimbus 又写回第一变体，则再次清空
    // ---------------------------------------------------------
    var idInput =
      form.querySelector('input[name="id"]');

    if (idInput) {
      var interval = setInterval(function () {
        if (userInteracted) {
          clearInterval(interval);
          return;
        }

        if (idInput.value) {
          resetForm(form);
        }
      }, 100);

      // 2.5 秒后停止轮询
      setTimeout(function () {
        clearInterval(interval);
      }, 2500);

      // 同时观察 value attribute
      var mo = new MutationObserver(function () {
        if (!userInteracted && idInput.value) {
          resetForm(form);
        }
      });

      mo.observe(idInput, {
        attributes: true,
        attributeFilter: ['value']
      });

      setTimeout(function () {
        mo.disconnect();
      }, 2500);
    }
  }

  // =========================================================
  // 初始化当前页面已有的 product form
  // =========================================================
  function initExistingForms() {
    document
      .querySelectorAll(
        'product-form form, form[action*="/cart/add"]'
      )
      .forEach(function (form) {
        armForm(form);
      });
  }

  // =========================================================
  // Quick View / Ajax / 动态 section 插入
  // =========================================================
  var moPage = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      (m.addedNodes || []).forEach(function (node) {
        if (!(node instanceof HTMLElement)) return;

        if (
          node.matches &&
          node.matches(
            'product-form form, form[action*="/cart/add"]'
          )
        ) {
          armForm(node);
        }

        if (node.querySelectorAll) {
          node
            .querySelectorAll(
              'product-form form, form[action*="/cart/add"]'
            )
            .forEach(function (form) {
              armForm(form);
            });
        }
      });
    });
  });

  moPage.observe(document.body, {
    childList: true,
    subtree: true
  });

  // =========================================================
  // DOM 初始化
  // =========================================================
  function boot() {
    console.log(
      'SOLKATT product forms:',
      document.querySelectorAll(
        'product-form form, form[action*="/cart/add"]'
      ).length
    );

    setTimeout(initExistingForms, 30);
    setTimeout(initExistingForms, 120);
    setTimeout(initExistingForms, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      boot
    );
  } else {
    boot();
  }

  // =========================================================
  // Shopify Theme Editor / Ajax section
  // =========================================================
  [
    'shopify:section:load',
    'shopify:section:select',
    'facets:updated'
  ].forEach(function (ev) {
    document.addEventListener(ev, function () {
      setTimeout(initExistingForms, 30);
    });
  });

  // =========================================================
  // 用户真正选中有效 variant 后恢复按钮
  // =========================================================
  document.addEventListener(
    'change',
    function (e) {
      if (resetting) return;

      // 这里只处理真实用户 change
      if (!e.isTrusted) return;

      var form =
        getProductFormFromTarget(e.target);

      if (!getVariantPicker(form)) return;

      // 给 Nimbus 一点时间写回 variant ID
      setTimeout(function () {
        var idInput =
          form.querySelector('input[name="id"]');

        var addBtn =
          form.querySelector('button[name="add"]') ||
          form.querySelector('[type="submit"]');

        if (
          idInput &&
          idInput.value &&
          addBtn
        ) {
          addBtn.disabled = false;
          addBtn.removeAttribute('aria-disabled');

          if (addBtn.dataset.originalText) {
            addBtn.textContent =
              addBtn.dataset.originalText;
          }
        }
      }, 80);
    },
    true
  );
})();


/* ============================================================
   无 ?variant= 时强制首屏展示产品第一张图片
============================================================ */

(function () {
  if (new URLSearchParams(location.search).has('variant')) {
    return;
  }

  function showFirstImage(root) {
    var scope = root || document;

    var gallery =
      scope.querySelector('media-gallery') ||
      scope.querySelector('.product__media-gallery') ||
      scope.querySelector('.product-media-modal-opener');

    if (!gallery) return;

    var firstThumb =
      gallery.querySelector(
        '[data-thumbnail][data-media-id]'
      ) ||
      gallery.querySelector(
        '[data-media-id]'
      ) ||
      gallery.querySelector(
        '.thumbnail-list__item [data-target]'
      ) ||
      gallery.querySelector(
        '.thumbnail'
      );

    if (!firstThumb) return;

    var mediaId =
      firstThumb.dataset.mediaId ||
      firstThumb.getAttribute('data-target');

    try {
      if (
        typeof gallery.setActiveMedia === 'function' &&
        mediaId
      ) {
        gallery.setActiveMedia(
          mediaId,
          true
        );
      } else {
        firstThumb.dispatchEvent(
          new Event('click', {
            bubbles: true
          })
        );
      }
    } catch (e) {
      setTimeout(function () {
        if (
          typeof gallery.setActiveMedia === 'function' &&
          mediaId
        ) {
          gallery.setActiveMedia(
            mediaId,
            true
          );
        } else {
          firstThumb.dispatchEvent(
            new Event('click', {
              bubbles: true
            })
          );
        }
      }, 60);
    }
  }

  function bootGallery() {
    setTimeout(function () {
      showFirstImage(document);
    }, 30);

    setTimeout(function () {
      showFirstImage(document);
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      bootGallery
    );
  } else {
    bootGallery();
  }

  [
    'shopify:section:load',
    'shopify:section:select',
    'facets:updated'
  ].forEach(function (ev) {
    document.addEventListener(ev, function () {
      setTimeout(function () {
        showFirstImage(document);
      }, 30);
    });
  });

  var mo =
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        (m.addedNodes || []).forEach(
          function (node) {
            if (
              !(node instanceof HTMLElement)
            ) {
              return;
            }

            if (
              (
                node.matches &&
                (
                  node.matches('media-gallery') ||
                  node.matches(
                    '.product__media-gallery'
                  )
                )
              ) ||
              (
                node.querySelector &&
                node.querySelector(
                  'media-gallery, .product__media-gallery'
                )
              )
            ) {
              showFirstImage(node);
            }
          }
        );
      });
    });

  mo.observe(document.body, {
    childList: true,
    subtree: true
  });
})();